import React from 'react';
import PropTypes from 'prop-types';

// Components
import LoadingArea from '@molecules/LoadingArea';
import PopoverSelect from '@molecules/PopoverSelect';

// Functionality
import useViewerEvents from '@hooks/useViewerEvents';

const PopoverSelectEventsForViewer = ({ selectedEvent, onSelect }) => {
    const { data: events } = useViewerEvents({ futureOnly: true });

    if (!events) {
        return <LoadingArea />;
    }

    return (
        <PopoverSelect
            placeholder="Filter by Event"
            options={events}
            optionIdProp="recordId"
            optionLabelProp="title"
            selectedOption={selectedEvent}
            onSelect={selectedOption => {
                onSelect(selectedOption);
            }}
        />
    );
};

PopoverSelectEventsForViewer.propTypes = {
    selectedEvent: PropTypes.object,
    onSelect: PropTypes.func,
};

export default PopoverSelectEventsForViewer;
